import { FC, useState } from "react";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import ModalDialog from "../../../../ui/ModalDialog";
import CurveIntermediateForm from "./CurveIntermediateForm";

const CreateCurveIntermediateModalDialogButton: FC = () => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }}>{i18n.translation.common.createNew}</Button>
      {show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.translation.patrolCurveIntermediates.createNew}>
          <CurveIntermediateForm onClose={() => setShow(false)} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateCurveIntermediateModalDialogButton;
